module.exports = __webpack_public_path__ + "static/media/Ship-Meraviglia-MSC-aurea-spa.1a89032e.jpg";